import { DataContractConfigApi } from '@elementary/common-ui/types';
import useSidePanelParams from '@elementary/common-ui/hooks/useSidePanelParams';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import { useMutation } from '@tanstack/react-query';
import { updateDataContractConfig } from 'shared/services/api';
import { DataContractTestConfig, TestOverview } from '../types';
import useTestConfiguration from './useTestConfiguration';

function useDataContractTestConfiguration(testOverview: TestOverview) {
  const selectedEnvId = useSelectedEnv();
  const { selectedId } = useSidePanelParams();

  const {
    testConfigData,
    isTestConfigLoading,
    isTestConfigFetching,
    refetch: refetchTestConfiguration,
  } = useTestConfiguration({ testId: testOverview.execution?.testId });

  const { mutate: updateConfig, isLoading: isUpdating } = useMutation(
    (formData: DataContractConfigApi) =>
      updateDataContractConfig(selectedEnvId!, selectedId!, formData),
  );

  const testConfig = isTestConfigFetching
    ? undefined
    : (testConfigData?.test?.config as DataContractTestConfig | undefined);

  return {
    testConfig,
    refetchTestConfiguration,
    updateConfig,
    isFetching: isTestConfigLoading,
    isUpdating,
  };
}

export default useDataContractTestConfiguration;
